import { render, staticRenderFns } from "./UiUxDesign.vue?vue&type=template&id=745ab089&"
import script from "./UiUxDesign.vue?vue&type=script&lang=js&"
export * from "./UiUxDesign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports